export default {
  mailFormatError: 'Correo inválido. Prueba formato nombre@mail.com',
  mailRequiredError: 'Escribe tu dirección de correo electrónico.',
  nameRequiredError: 'Escribe tu nombre completo para completar tu perfil',
  termsAndConditions: 'Debe aceptar los términos y condiciones',
  invalidPassword: 'La contraseña no cumple con los requisitos mínimos',
  phoneNumberRequiredError: 'Escribe tu número de teléfono',
  positionRequiredError: 'Indícanos cual es tu cargo en la escuela para completar tu perfil',
  isNecessarySelect: 'Es necesario seleccionar {msg}',
  wrongCredentialsError: 'La cuenta seleccionada no coincide con el usuario invitado'
}

export const en = {
  mailFormatError: 'Invalid email. Try the name@mail.com format',
  mailRequiredError: 'Enter your email address.',
  nameRequiredError: 'Enter your full name to complete your profile',
  termsAndConditions: 'You must accept the terms and conditions',
  invalidPassword: 'The password does not meet the requirements',
  phoneNumberRequiredError: 'Enter your phone number',
  positionRequiredError: 'Please tell us your position in the school to complete your profile.',
  isNecessarySelect: 'You need to select {msg}',
  wrongCredentialsError: 'La cuenta seleccionada no coincide con el usuario invitado'
}

export const ca = {
  mailFormatError: 'Correu invàlid. Prova de format no,@mail.com',
  mailRequiredError: 'Escriu la teva adreça de correu electrònic.',
  nameRequiredError: 'Escriu el teu nom sencer per completar el teu perfil',
  termsAndConditions: 'Has d\'acceptar els termes i condicions',
  invalidPassword: 'La paraula de pas no compleix amb els requisits mínims',
  phoneNumberRequiredError: 'Escriu el teu número de telèfon',
  positionRequiredError: 'Indica\'ns quin és el teu càrrec a l\'escola per a completar el teu perfil',
  isNecessarySelect: 'És necessari seleccionar {msg}',
  wrongCredentialsError: 'La cuenta seleccionada no coincide con el usuario invitado'
}
